angular.module('picmonicng').directive('referralCopyGroup', function () {
  return {
    restrict: 'E',
    templateUrl: '/templates/directives/referral-copy-group.html',
    controller: [
      '$scope',
      'UserService',
      'toaster',
      function ($scope, UserService, toaster) {
        if ($scope.referral_padded !== false && $scope.referral_padded !== 'false') {
          $scope.referral_padded = true;
        }

        $scope.referral_url = UserService.getFullReferralUrl() + '?redirect=' + window.location.pathname;

        $scope.copy = function () {
          send_ga('event', 'Referral', 'Copy Share Link');
          toaster.success('Copied', 'URL has been copied to the clipboard.');
        };
      },
    ],
    link: function (scope, element, attrs) {
      var button = element.find('.copy-group .pls-btn');
      // Clipboard copy support
      button.bind('click', scope.copy);
    },
  };
});
